const TEMP_PAGE_DATA = "TEMP_PAGE_DATA";
const TEMP_PAGE_MODE = "TEMP_PAGE_MODE";
const TEMP_PAGE_BRAND = "TEMP_PAGE_BRAND";
const initTempData = data => ({
  type: TEMP_PAGE_DATA,
  data: data
});
const changeTempPageMode = mode => ({
  type: TEMP_PAGE_MODE,
  mode: mode
});
const switchNoPageBrand = noBrand => ({
  type: TEMP_PAGE_BRAND,
  noBrand: noBrand
});

const GLOBAL_ACTION_EDIT = "GLOBAL_ACTION_EDIT";
const contentEditing = (editing, ext) => ({
  type: GLOBAL_ACTION_EDIT,
  editing: editing,
  extra: ext
});
export {
  GLOBAL_ACTION_EDIT,
  contentEditing,
  TEMP_PAGE_DATA,
  initTempData,
  TEMP_PAGE_MODE,
  changeTempPageMode,
  TEMP_PAGE_BRAND,
  switchNoPageBrand
};
